<template>
  <div>
    <van-search v-model="code" placeholder="请输入搜索关键词" class="search" />
    <van-tabs
      v-model="active"
      color="#2B71FE"
      line-width="30"
      title-active-color="#2B71FE"
      title-inactive-color="#707070"
      @change="changeTitle"
    >
      <van-tab title="全部" name="0"></van-tab>
      <van-tab title="今天" name="1"></van-tab>
      <van-tab title="昨天" name="2"></van-tab>
      <van-tab title="本周" name="3"></van-tab>
      <van-tab title="上周" name="4"></van-tab>
    </van-tabs>
    <p class="title">
      <span>核销标签码数量：{{ total }}</span>
      <span>标签总数量：{{ tagTotal }}</span>
    </p>
    <div class="list" ref="listout">
      <van-list @load="onLoad" v-model="loadFinish" :finished="finished">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item-content" :style="{}">
            <p>二维码值： {{ item.code }}</p>
            <p>核销时间：{{ item.check_time }}</p>
            <p>
              <span> 标签数量：{{ item.tag_number }} </span>
              <span style="float: right">
                核销用户：{{ item.check_user_name }}
              </span>
            </p>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { getTagList } from '@/api/printer'
export default {
  data() {
    return {
      active: 0,
      list: [],
      loadFinish: false,
      finished: false, //加载完成
      page: 1,
      pageSize: 10,
      userList: [],
      total: null,
      tagTotal: null,
      startTime: null,
      endTime: null,
      code: '',
      timeOut: null,
    }
  },
  created() {},
  computed: {},
  watch: {
    code(news, old) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.list = []
        this.page = 1
        this.loadFinish = false
        this.finished = false
        this.$refs.listout.scrollTop = 0
        this.onLoad()
      }, 1000)
    },
  },
  methods: {
    onLoad() {
      this.loadFinish = true
      this.getList()
    },
    changeTitle() {
      this.list = []
      this.page = 1
      this.loadFinish = false
      this.finished = false
      this.$refs.listout.scrollTop = 0
      const today = new Date()
      let year, month, day
      switch (this.active) {
        case '0':
          this.startTime = null
          this.endTime = null
          break
        case '1':
          // 今天
          year = today.getFullYear()
          month = today.getMonth() + 1
          day = today.getDate()
          this.startTime = `${year}-${month}-${day} 00:00:00`
          this.endTime = `${year}-${month}-${day} 23:59:59`
          break
        case '2':
          // 昨天
          const yesterday = new Date(today)
          yesterday.setDate(today.getDate() - 1)
          year = yesterday.getFullYear()
          month = yesterday.getMonth() + 1
          day = yesterday.getDate()
          this.startTime = `${year}-${month}-${day} 00:00:00`
          this.endTime = `${year}-${month}-${day} 23:59:59`
          break
        case '3':
          // 本周
          const currentDayOfWeek = today.getDay()
          const firstDayOfWeek = new Date(today)
          firstDayOfWeek.setDate(today.getDate() - currentDayOfWeek + 1)
          const lastDayOfWeek = new Date(today)
          lastDayOfWeek.setDate(today.getDate() + (7 - currentDayOfWeek))
          this.startTime = `${firstDayOfWeek.getFullYear()}-${
            firstDayOfWeek.getMonth() + 1
          }-${firstDayOfWeek.getDate()} 00:00:00`
          this.endTime = `${lastDayOfWeek.getFullYear()}-${
            lastDayOfWeek.getMonth() + 1
          }-${lastDayOfWeek.getDate()} 23:59:59`
          break
        case '4':
          // 上周
          const firstDayWeek = new Date(today)
          firstDayWeek.setDate(today.getDate() - today.getDay())

          const lastDayOfLastWeek = new Date(firstDayWeek)
          lastDayOfLastWeek.setDate(firstDayWeek.getDate() - 1)

          const firstDayOfLastWeek = new Date(lastDayOfLastWeek)
          firstDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() - 6)

          const startYear = firstDayOfLastWeek.getFullYear()
          const startMonth = firstDayOfLastWeek.getMonth() + 1
          const startDate = firstDayOfLastWeek.getDate()

          const endYear = lastDayOfLastWeek.getFullYear()
          const endMonth = lastDayOfLastWeek.getMonth() + 1
          const endDate = lastDayOfLastWeek.getDate()

          this.startTime = `${startYear}-${
            startMonth < 10 ? '0' + startMonth : startMonth
          }-${startDate < 10 ? '0' + startDate : startDate} 23:59:59`
          this.endTime = `${endYear}-${
            endMonth < 10 ? '0' + endMonth : endMonth
          }-${endDate < 10 ? '0' + endDate : endDate} 23:59:59`
          break
        default:
          break
      }
      this.onLoad()
    },
    getList() {
      let params = {
        page: this.page,
        per_page: 10,
        // check_start_time: '2024-4-15 00:00:00',
        // check_end_time: '2024-4-15 23:59:59',
        check_start_time: this.startTime,
        check_end_time: this.endTime,
        search: this.code,
        type: 2,
      }
      getTagList(params).then((res) => {
        this.page++
        this.total = res.total
        this.tagTotal = res.tag_number_total
        if (res && res.data && res.data.length > 0) {
          this.list.push(...res.data)
          if (res.data.length < 10) {
            this.finished = true
          }
          setTimeout(() => {
            this.loadFinish = false
          }, 200)
        } else {
          this.finished = true
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.search {
  width: 996px;
  margin-left: 65px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 2px;
}
::v-deep .van-icon {
  font-size: 50px !important;
}
::v-deep.van-search__content {
  background-color: rgba(0, 0, 0, 0);
}
::v-deep input::placeholder {
  color: #707070;
  font-size: 42px;
}
.title {
  color: #313131;
  font-size: 42px;
  margin-top: 64px;
  font-weight: 400;
  span:nth-child(1) {
    margin-left: 65px;
  }
  span:nth-child(2) {
    float: right;
    margin-right: 65px;
  }
}
.list {
  margin-left: 65px;
  margin-bottom: 50px;
  .item {
    margin-top: 45px;
    &-title {
      font-size: 42px;
      color: #313131;
      margin-top: 64px;
      margin-bottom: 36px;
      font-weight: 400;
    }
    &-content {
      width: 994px;
      height: 257px;
      background: linear-gradient(-40deg, #44d0c9, #6faee2, #2b71fe);
      box-shadow: 0px 0px 13px 2px rgba(88, 87, 87, 0.1);
      border-radius: 5px;
      color: #fdfcfc;
      font-size: 36px;
      padding: 38px;
      p:nth-child(1) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p:nth-child(2) {
        margin-top: 8px;
      }
      p:nth-child(3) {
        margin-top: 8px;
      }
    }
  }
}
</style>
